import { NavigationGuardNext, Route } from 'vue-router'
import MarketingService from '@/services/marketing-service'
import { getEnvironment } from '@/utils/env-helper'

async function appendUtmGuard(to: Route, from: Route, next: NavigationGuardNext) {
  if (to.query.utm_campaign || to.path.includes('super-admin') || getEnvironment() !== 'Live') {
    return next()
  }

  const campaign = MarketingService.getCampaign()
  if (campaign) {
    return next({ path: to.path, query: { ...to.query, ...campaign } })
  }

  return next()
}

export default appendUtmGuard
